import Cookies from 'js-cookie';

export default function useAuth() {
    const set = (user: any, token: string, authenticated: boolean, isMentor: boolean = false) => {
        Cookies.set("token", token, { expires: 2 })
        if (authenticated) {
            Cookies.set("authenticated", "true", { expires: 2 })
            Cookies.set("user", JSON.stringify(user), { expires: 2 })
            Cookies.set("isMentor", isMentor.toString(), { expires: 2 })
        }
    }

    const del = () => {
        Cookies.remove("token")
        Cookies.remove("authenticated")
        Cookies.remove('user')
        Cookies.remove('isMentor')
    }

    const get = () => {
        return {
            token: Cookies.get("token"),
            user: Cookies.get("user"),
            authenticated: Cookies.get("authenticated"),
            isMentor: Cookies.get("isMentor")
        }
    }

    return {
        set, del, get
    }
}